import { useState, useEffect } from "react";
import { motion } from "framer-motion";
import { Menu, X, Phone } from "lucide-react";

const nav = [
  { label: "Instruments", href: "#showcase" },
  { label: "Maison", href: "#maison" },
  { label: "Boutique", href: "#shop" },
  { label: "SoundYoga", href: "#partner" },
  { label: "Contact", href: "#contact" },
];

export default function Header() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <motion.header
      initial={{ y: -80, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      transition={{ duration: 0.8, ease: [0.16, 1, 0.3, 1] }}
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-500 ${
        scrolled
          ? "bg-cream/80 backdrop-blur-md border-b border-ink/5"
          : "bg-transparent"
      }`}
      data-testid="main-header"
    >
      <div className="max-w-[1400px] mx-auto px-6 md:px-10 py-4 flex items-center justify-between">
        <a href="#top" className="flex items-center gap-3" data-testid="logo-link">
          <img
            src="https://static.wixstatic.com/media/818fcb_f48e0930618241f0a1e35a8a231fe389~mv2.png"
            alt="Yogi Market Compiègne"
            className="h-10 md:h-11 w-auto object-contain"
          />
        </a>

        <nav className="hidden lg:flex items-center gap-10">
          {nav.map((n) => (
            <a
              key={n.href}
              href={n.href}
              className="text-sm text-ink/70 hover:text-terracotta transition-colors relative group"
              data-testid={`nav-${n.label.toLowerCase()}`}
            >
              {n.label}
              <span className="absolute -bottom-1 left-0 w-0 h-[1px] bg-terracotta group-hover:w-full transition-all duration-300" />
            </a>
          ))}
        </nav>

        <div className="hidden md:flex items-center gap-3">
          <a
            href="tel:+33767396699"
            className="flex items-center gap-2 text-sm text-ink/80 hover:text-terracotta transition"
            data-testid="phone-link-header"
          >
            <Phone size={14} /> 07 67 39 66 99
          </a>
          <a
            href="https://www.yogimarket.fr/category/all-products"
            target="_blank"
            rel="noreferrer"
            className="px-6 py-2.5 rounded-full bg-ink text-cream text-sm hover:bg-terracotta transition-all duration-300 hover:scale-105"
            data-testid="shop-cta-header"
          >
            Boutique
          </a>
        </div>

        <button
          onClick={() => setOpen(!open)}
          className="lg:hidden text-ink"
          data-testid="mobile-menu-toggle"
        >
          {open ? <X size={24} /> : <Menu size={24} />}
        </button>
      </div>

      {open && (
        <motion.div
          initial={{ opacity: 0, y: -10 }}
          animate={{ opacity: 1, y: 0 }}
          className="lg:hidden bg-cream/95 backdrop-blur-md border-t border-ink/5 px-6 py-6 space-y-4"
        >
          {nav.map((n) => (
            <a
              key={n.href}
              href={n.href}
              onClick={() => setOpen(false)}
              className="block text-lg font-serif text-ink hover:text-terracotta"
              data-testid={`mobile-nav-${n.label.toLowerCase()}`}
            >
              {n.label}
            </a>
          ))}
          <a
            href="https://www.yogimarket.fr/category/all-products"
            className="block mt-4 px-6 py-3 rounded-full bg-ink text-cream text-center"
          >
            Boutique
          </a>
        </motion.div>
      )}
    </motion.header>
  );
}
